export const MODIFY_EVENT_STEPS_ID = {
  BASIC_DETAILS: 'basic-details',
  REGISTRATION_DETAILS: 'registration-details',
  PRICING_MODEL: 'pricing-model',
  REGISTRATION_FORM: 'registration-form',
} as const;

export const MODIFY_DISTANCE_STEPS_ID = {
  DISTANCE_DETAILS: 'distance-details',
  DISTANCE_EVENTS: 'distance-events',
} as const;

export const PRICING_STEPS_ID = {
  PRICING_MODEL: 'pricing-model',
  PRICING_MATRIX: 'pricing-matrix',
} as const;

export const REGISTRATION_FORM_COLUMN_ID = {
  FIELD_NAME: 'field-name',
  HIDE_FIELD: 'hide-field',
  FIELD_VISIBLE: 'field-visible',
  FIELD_MANDATORY: 'field-mandatory',
} as const;

export const PRICING_COLUMN_ID = {
  DISTANCE_AND_GROUP: 'distance-and-group',
  PRICE_START: 'price-start',
  ACTIONS: 'actions',
};

export const REGISTRATION_FORM_INPUT_TYPE = {
  RADIO: 'radio',
  CHECKBOX: 'checkbox',
} as const;

export const IS_HIDDEN_SUFFIX = 'is_hidden';
export const IS_MANDATORY_SUFFIX = 'is_mandatory';
